/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FilestoreInfo } from './FilestoreInfo';
import {
    FilestoreInfoFromJSON,
    FilestoreInfoFromJSONTyped,
    FilestoreInfoToJSON,
} from './FilestoreInfo';

/**
 * 
 * @export
 * @interface GetOrCreateListResponse
 */
export interface GetOrCreateListResponse {
    /**
     * 
     * @type {Array<FilestoreInfo>}
     * @memberof GetOrCreateListResponse
     */
    filestores?: Array<FilestoreInfo>;
    /**
     * 
     * @type {string}
     * @memberof GetOrCreateListResponse
     */
    error?: string;
}

/**
 * Check if a given object implements the GetOrCreateListResponse interface.
 */
export function instanceOfGetOrCreateListResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetOrCreateListResponseFromJSON(json: any): GetOrCreateListResponse {
    return GetOrCreateListResponseFromJSONTyped(json, false);
}

export function GetOrCreateListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOrCreateListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'filestores': !exists(json, 'filestores') ? undefined : ((json['filestores'] as Array<any>).map(FilestoreInfoFromJSON)),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function GetOrCreateListResponseToJSON(value?: GetOrCreateListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'filestores': value.filestores === undefined ? undefined : ((value.filestores as Array<any>).map(FilestoreInfoToJSON)),
        'error': value.error,
    };
}

